<script>
  import Menu from "@/components/Menu.svelte";
  import googleSample from "./_googleSample.js";
  export let form, productName;

  const GOOGLE_API_KEY = "AIzaSyDF3rQFnI22jwAOKgWzN4JGe_kN-TLzpu4";
  const GOOGLE_SEACH_ENGINE = "002234451493092961709:pqeik5phgb5";

  let nameSuggestions = false;
  let showMenu = false;
  let showNameSuggestions = false;

  
  async function fetchNameSuggestions() {
    const response = await fetch(`https://www.googleapis.com/customsearch/v1?q=${form.EANCode}&key=${GOOGLE_API_KEY}&cx=${GOOGLE_SEACH_ENGINE}`);
    const json = await response.json();
    // const json = googleSample;
    nameSuggestions = json.items || [];
  }
</script>

<span class="absolute top-0 right-0 mr-6 mt-2">
  <Menu align="right">
    <span slot="activator">menu</span>
    <div class="bg-white px-3 py-2 shadow whitespace-no-wrap ">
      <div>
        <a href={'/logs/product/' + form._id}>Log</a>
      </div>
      <div>
        <a href={'https://www.google.com/search?q=' + form.EANCode} target="_blank">
          Søg på Google
        </a>
      </div>
              {#if !form.ItemText1 && form.EANCode}
      <div>
        <Menu style="width:100%" bind:show={showNameSuggestions}>
          <button
            class="w-full text-left"
            slot="activator"
            on:click|once={fetchNameSuggestions}>
            Søg navn
          </button>
          <div class="bg-white px-3 py-2 shadow whitespace-no-wrap">
            {#if nameSuggestions}
              <ul>
                {#each nameSuggestions as name}
                  <li>
                    <div
                      class="cursor-pointer"
                      on:click={() => {
                        productName = name.title;
                        showNameSuggestions = false;
                      }}>
                      {name.title}
                    </div>
                  </li>
                {:else}
                    [Fandt intet]
                {/each}
                
              </ul>
            {/if}
          </div>
        </Menu>
      </div>
      {/if}
    </div>
  </Menu>
</span>
  